import React, { Component } from "react";
import "antd/dist/antd.css";
import { NavLink } from "react-router-dom";
import Call from "../Images/call.png";
import Exit from "../Images/exit.png";
import Profile from "../Images/profile.png";
import Settings from "../Images/settings.png";
import Iconcart from "../Images/Iconcart.png";
import {
  Row,
  Col,
  Dropdown,
  Layout,
  Menu,
  Select,
  Button,
  Badge,
  Spin,
  message,
  Popover,
  Card,
  Tag,
  Modal,
  Input,
  Divider,
  Tooltip,
  notification,
  Table,
} from "antd";
import { BellOutlined, DownOutlined, CloseOutlined } from "@ant-design/icons";
import { withRouter } from "react-router";
import { withAppContext } from "../store/contextStore";
import { Link } from "react-router-dom";
import Trash from "../Images/trash.png";
import AppConfigs from "../Config/AppConfig";
import { Storage } from "aws-amplify";
import { list, update, deleteRecord, add } from "../api/Apis";
import newLogo from "../Images/newLogo.JPG";
import adminLogo from "../Images/adminlogo.png";
import userLogo from "../Images/user-logo.png";
import carrierTruck from "../Images/carrier-truck.png";
import orderLogo from "../Images/order-logo.png";
import orderStatus from "../Images/order-status.png";
import moment from "moment";
import NumberFormat from "react-number-format";
import priceFormate, { formatPhoneNumber } from "../Containers/commonFunctions";

const { Option } = Select;
const { TextArea } = Input;
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opencart: false,
      cartLoading: false,
      cartData: [],
      visible: false,
      notifications: {},
      custmerNotifications: [],
      notificationsList: [],
      notificationsCount: 0,
      notificationVisible: false,
      menuCollapsed: true,
      profilePic: "",
      updateProfilePic: "",
      lowLimitErrorMsg: "",
      modalVisible: false,
      to: "support@bulkmaterialpro.com",
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
    this.changeMeasurementType = this.changeMeasurementType.bind(this);
  }
  onLogout = () => {
    this.props.context.dropUser();
    this.props.history.push("/login");
    window.location.reload();
  };
  opencart = () => {
    // let cartData = this.props.context.state.cartData;
    // if (cartData.length > 0) {
    this.setState({
      opencart: !this.state.opencart,
    });
    // }
    // else {
    //   alert("No items in cart");
    // }
  };

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuCollapsed: !prevState.menuCollapsed,
    }));
  };

  componentDidMount = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    // localStorage.setItem("cartData", JSON.stringify([]));
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    if (
      userDetails &&
      (userDetails.userProfile === "CU" || userDetails.userProfile === "SCU")
    ) {
      if (
        parseFloat(orgDetails["creditAmount"]) &&
        parseFloat(orgDetails["presentCreditAmount"])
      ) {
        let calculatePer =
          parseFloat(orgDetails["creditAmount"]) -
          parseFloat(orgDetails["creditAmount"]) * 0.8;
        if (calculatePer > parseFloat(orgDetails["presentCreditAmount"])) {
          this.setState({
            lowLimitErrorMsg: "Your credit amount is very low please increase!",
          });
        }
      }
      // const result = await this.getCartData();
      this.getAuditTrailsDetails();
      this.getCartData();
      // console.log("++++", result);
    } else if (userDetails && userDetails.userProfile === "A") {
      this.getNotifications();
    }
    let profilePic = "";
    if (userDetails && userDetails["profilePic"]) {
      profilePic = await Storage.get(userDetails["profilePic"]);
    }
    this.setState({
      profilePic: profilePic,
      updateProfilePic: userDetails && userDetails["profilePic"],
      from: userDetails?.firstName + " " + userDetails?.lastName,
      email: userDetails?.email,
      phone: orgDetails?.phone,
    });
    this.callSetInterval();
    this.getRolesConfig();
  };

  getRolesConfig = () => {
    list("manageRoleConfig").then((res) => {
      if (res.success) {
        let userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (userDetails.userProfile === "A") {
          this.props.context.setRoles(
            res.data?.[0]?.rolesList.filter((m) => m.userType === "A" && m)
          );
        } else {
          this.props.context.setRoles(
            res.data?.[0]?.rolesList.filter((m) => m.userType === "M" && m)
          );
        }
      }
    });
  };

  callSetInterval = () => {
    this.clearNotificationApi = setInterval(async () => {
      if (
        this.state.userDetails &&
        (this.state.userDetails.userProfile === "CU" ||
          this.state.userDetails.userProfile === "SCU")
      ) {
        this.getAuditTrailsDetails();
      } else {
        this.getNotifications();
      }
    }, 30000);
  };

  getAuditTrailsDetails = () => {
    list("auditTrail", {
      typeofPage: "customerDetails",
      recordId: this.state.userDetails.carrierDetails?.id,
      isActive: true,
    })
      .then((details) => {
        if (details.success) {
          let totalAudit = details.data.sort((a, b) =>
            parseInt(a.updatedAt) < parseInt(b.updatedAt) ? 1 : -1
          );
          this.setState({
            custmerNotifications: totalAudit,
            notificationsList: details.data,
            pageLoadingStatus: false,
            notificationsCount: totalAudit.length,
          });
        }
      })
      .catch((err) => console.log(err, "errrrr"));
  };

  getNotifications = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let query = {
      orgId: orgDetails?.["id"],
      isActive: true,
    };
    list(AppConfigs["entityNames"]["notifications"], query).then((result) => {
      if (result.success) {
        let notifications = {},
          notificationsCount = 0;
        let notificationsData = result.data.sort((a, b) =>
          parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
        );
        notificationsData.map((notification) => {
          let dayFormat =
            moment(notification["createdAt"]).format("dddd, DD MMMM") ===
            moment().format("dddd, DD MMMM")
              ? "Today"
              : moment(notification["createdAt"]).format("dddd, DD MMMM");
          if (dayFormat in notifications) {
            notifications[dayFormat].push(notification);
          } else {
            notifications[dayFormat] = [];
            notifications[dayFormat].push(notification);
          }
          notificationsCount += 1;
          return notification;
        });
        this.setState({
          notificationsList: result.data,
          notifications: notifications,
          notificationsCount: notificationsCount,
          pageLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  getCartData = async () => {
    list(AppConfigs["getCartData"] + "/" + this.state.orgDetails.id, {}).then(
      async (result) => {
        if (result.success) {
          let cartData = result.data;
          if (cartData.length === 0) {
            this.props.context.setCartData(cartData);
          } else {
            cartData.map(async (item) => {
              item["originalPath"] = item["image"];
              item["image"] = await Storage.get(item["image"]);
              this.setState({
                cartData: [...this.state.cartData, item],
              });
              this.props.context.setCartData(cartData);
              localStorage.setItem("cartData", JSON.stringify(cartData));
            });
          }
        } else {
          console.log(result.errors);
          this.setState({
            dataLoadingStatus: false,
          });
        }
        this.setState({
          cartLoading: false,
        });
      }
    );
  };
  addToCart = async (item, location) => {
    let itemType = "";
    let query = {
      size: item.size,
    };
    await list(
      `${AppConfigs["getProductDetails"]}/${item.productId}`,
      query
    ).then(async (result) => {
      if (result.success) {
        itemType =
          result.data["productCategory"] ===
          "37638d60-2b19-11eb-b05c-a3fa7baaf1b4"
            ? "bulk"
            : "pallet";
      } else {
        console.log(result.errors);
      }
    });
    // let tonValue =
    //   this.state.stoneWeight !== ""
    //     ? this.state.stoneWeight
    //     : this.state.stoneData[0]["pallet"] !;

    // let palletValue = this.state.stoneData.filter(
    //   (p) => p.ton === tonValue && p
    // );
    // if (palletValue[0].pallet === "0") {
    //   message.error("This product is currently not available by the pallet");
    //   return;
    // } else
    if (item.measurementType === "") {
      // alert("Please select measurement");
      message.error("Please select measurement");
      return;
    } else if (item.count === 0) {
      // alert("Please select quantity");
      message.error("Please select quantity");
      return;
    } else if (
      item.deliveryTruck === "" &&
      item.measurementType === "Truckload"
    ) {
      // alert("Please select quantity");
      message.error("Please select Delivery Truck");
      return;
    }
    // else if (
    //   item.measurementType === "Truckload" &&
    //   item.stoneData[0]["truckload"] === "0"
    // ) {
    //   // alert("Please select quantity");
    //   message.error("This product is currently not available by the truckload");
    //   return;
    // }
    //  else if (this.state.stoneData[0]["ton"] === "0") {
    //   // alert("Please select quantity");
    //   message.error("This product is currently not available by the ton");
    //   return;
    // }

    if (item.measurementType === "Truckload" && item.count > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    // if (location === "Milford") {
    //   this.setState({
    //     addToCartMilfordLoading: true,
    //   });
    // } else {
    this.setState({
      addToCartLoading: true,
    });
    // }
    let data = {
      entityData: {
        productId: item.productId,
        size: item.size,
        // ton:
        //   item.stoneWeight !== ""
        //     ? item.stoneWeight
        //     : item.stoneData[0]["pallet"] !== "0"
        //     ? item.stoneData[0]["ton"]
        //     : item.stoneData[1]["ton"],
        locationName: location,
        productLinkId: item.productId,
        measurementType: item.measurementType,
        deliveryTruck: item.deliveryTruck !== "" ? item.deliveryTruck : null,
        quantity: item.quantity,
        customerId: this.state.orgDetails["id"],
        orgId: this.state.orgDetails["orgId"],
        itemType: itemType,
      },
    };
    let existingCartData = JSON.parse(localStorage.getItem("cartData"));
    if (
      existingCartData &&
      existingCartData[0] &&
      existingCartData[0].deliveryTruck &&
      existingCartData[0].deliveryTruck !== item.deliveryTruck &&
      existingCartData[0].measurementType !== "Pallet"
    ) {
      if (
        (item.measurementType === "Pallet" &&
          existingCartData[0].measurementType !== "Pallet") ||
        (item.measurementType === "Truckload" &&
          existingCartData[0].measurementType === "Pallet")
      ) {
        notification["error"]({
          message: `You can only order bulk gravel or pallets in a single order. Please create separate orders for each`,
        });
        this.setState({
          addToCartLoading: false,
          addToCartMilfordLoading: false,
        });
        return;
      }
      // notification["error"]({
      //   message: `Your cart has a ${
      //     existingCartData[0].measurementType === "Pallet"
      //       ? "Pallet"
      //       : existingCartData[0].deliveryTruck
      //   } ordered with a different truck type.${
      //     existingCartData[0].measurementType === "Pallet"
      //       ? " Please select only one truck type for up to 24 pallets in each order. Thank you"
      //       : "Please select only one truck type in each order. Thank you"
      //   } .`,
      // });
      this.setState({
        addToCartLoading: false,
        addToCartMilfordLoading: false,
      });
      // return;
    }

    // const { stoneWeight, stoneData } = item;
    let total_weight = 0;
    if (existingCartData != null) {
      existingCartData.map((d) => (total_weight = total_weight + d.weight));
    }
    let check_total_weight;

    if (item.measurementType !== "Truckload") {
      let numOfTons;
      let checkProduct =
        existingCartData !== null &&
        existingCartData.filter(
          (c) =>
            c.productId === this.props.match.params.id &&
            item.measurementType === c.measurementType &&
            item.size === c.size
        );
      if (checkProduct.length > 0) {
        data["entityData"]["quantity"] =
          parseInt(checkProduct[0]["quantity"]) + parseInt(item.count);
        data["entityData"]["id"] = checkProduct[0]["id"];
        let totalTon =
          parseFloat(data["entityData"]["ton"].split(" Ton")[0]) *
          parseInt(item.count);
        numOfTons =
          parseFloat(checkProduct[0]["weight"]) + parseFloat(totalTon);
        // data["entityData"]["wieght"] = numOfTons;
      } else {
        let totalTon = data["entityData"]["ton"].split(" Ton");
        numOfTons = parseFloat(totalTon[0]) * data["entityData"]["quantity"];
        // data["entityData"]["wieght"] = numOfTons;
      }
      check_total_weight = total_weight + item.count;
      data["entityData"]["wieght"] = numOfTons;
    }

    add(AppConfigs["addItemToCart"], data).then((result) => {
      if (result.success) {
        let cartData = result.data.data;
        cartData &&
          cartData.map(async (item, index) => {
            item["originalPath"] = item["image"];
            item["image"] = await Storage.get(item["image"]);
            if (cartData.length === index + 1) {
              this.props.context.setCartData(cartData);
              localStorage.setItem("cartData", JSON.stringify(cartData));
              message.success("Product added to cart");
            }
          });
      } else {
        message.error(`Product not added to cart`);
        console.log(result.errors);
      }
      this.setState({
        addToCartLoading: false,
        deliveryTruck: "",
      });
      // window.location.reload();
    });
  };

  quantityIncrement = (item, measurementType, quantity, itemId) => {
    if (measurementType === "Truckload" && parseInt(quantity) + 1 > 1) {
      // message.error("Only 1 truckload can be ordered at a time.");
      this.addToCart(item, item.locationName);
      return;
    }
    this.setState({
      cartLoading: true,
    });
    let data = {
      entityData: {
        quantity: quantity + 1,
        totalAmt: (item.totalAmt / quantity) * (quantity + 1),
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        // window.location.reload();
        this.setState({
          cartData: [],
          opencart: true,
          cartLoading: false,
        });
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };
  quantityDecrement = (item, quantity, itemId) => {
    this.setState({
      cartLoading: true,
    });
    let data = {
      entityData: {
        quantity: quantity - 1,
        totalAmt: (item.totalAmt / quantity) * (quantity - 1),
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.setState({
          opencart: true,
          cartData: [],
          cartLoading: false,
        });
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };

  changeMeasurementType = async (
    measurementType,
    itemId,
    quantity,
    totalAmt
  ) => {
    if (measurementType === "Truckload" && parseInt(quantity) > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    // else if(measurementType === "Pallet" && totalAmt === 0){
    //   message.error('This product is currently not available by the pallet');
    //   return;
    // }
    this.setState({
      cartLoading: true,
    });
    let data = {
      entityData: {
        measurementType: measurementType,
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.setState({
          opencart: true,
          cartData: [],
          cartLoading: false,
        });
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };

  deleteCartItem = async (itemId) => {
    this.setState({
      cartLoading: true,
    });

    deleteRecord(AppConfigs["entityNames"]["cart"], itemId).then((result) => {
      if (result.success) {
        message.success("Product deleted successfully");
        localStorage.removeItem("cartData");
        this.getCartData();
        // window.location.reload();
      } else {
        console.log(result.errors);
      }
    });
  };

  checkout = () => {
    let cartdata = JSON.parse(localStorage.getItem("cartData"));
    // console.log(cartdata[0]["measurementType"])
    if (cartdata[0]["totalAmt"] === 0) {
      message.error(
        "This product is currently not available by the " +
          cartdata[0]["measurementType"] +
          ""
      );
      return;
    } else {
      this.props.history.push("/app/stones/finishorder");
      this.setState({
        // opencart: false
        visible: false,
      });
    }
  };
  handleVisibleChange = (visible) => {
    this.setState({ visible });
  };
  notificationHandlechange = (notificationVisible) => {
    this.setState({ notificationVisible, notificationLoading: true });
  };

  openDeatilsPage = (recordType, recordId, id) => {
    this.setState({ notificationVisible: false });
    let recordIds = [];
    if (recordId) {
      recordIds = [id];
    } else {
      this.state.notificationsList.map((n) => {
        recordIds.push(n["id"]);
        return n;
      });
    }
    recordIds.map((notification) => {
      let data = {
        entityData: {
          isActive: false,
        },
      };
      if (
        this.state.userDetails &&
        (this.state.userDetails.userProfile === "CU" ||
          this.state.userDetails.userProfile === "SCU")
      ) {
        update("auditTrail", notification, data).then((result) => {
          if (result.success) {
            this.setState({
              custmerNotifications: [],
              notificationsList: [],
              notificationsCount: 0,
            });
          } else {
            console.log(result.errors);
          }
        });
      } else {
        update(
          AppConfigs["entityNames"]["notifications"],
          notification,
          data
        ).then((result) => {
          if (result.success) {
            console.log("remove");
          } else {
            console.log(result.errors);
          }
        });
      }
      return notification;
    });
    this.setState({
      notifications: [],
      notificationsList: [],
      notificationsCount: 0,
    });
    // this.getNotifications();
    if (recordType === "order") {
      this.props.history.push("/app/loads/loaddetails/" + recordId);
    } else if (recordType === "carrier") {
      this.props.history.push("/app/carriers/carrierdetails/" + recordId);
    } else if (recordType === "customer") {
      this.props.history.push("/app/customers/customerdetails/" + recordId);
    } else if (
      recordType === "notifications" &&
      (this.state.userDetails.userProfile === "A" ||
        this.state.userDetails.userProfile === "M")
    ) {
      this.props.history.push("/app/adminnotifications");
    } else if (
      recordType === "notifications" &&
      (this.state.userDetails.userProfile === "CU" ||
        this.state.userDetails.userProfile === "SCU")
    ) {
      this.props.history.push("/app/customerNotifications");
      // this.props.history.push("/app/adminnotifications");
    } else if (
      recordType === "notifications" &&
      (this.state.userDetails.userProfile === "CA" ||
        this.state.userDetails.userProfile === "SCA")
    ) {
      this.props.history.push("/app/carrierNotifications");
      // this.props.history.push("/app/adminnotifications");
    } else if (
      recordType === "notifications" &&
      this.state.userDetails.userProfile === "D"
    ) {
      this.props.history.push("/app/driverNotifications");
      // this.props.history.push("/app/carrierNotifications");
    }
  };

  handleMailForm = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSendMail = async () => {
    console.log(this.state);
    if (this.state.to === "") {
      message.error("Please enter to address");
      return;
    } else if (this.state.from === "") {
      message.error("Please enter from address");
      return;
    } else if (this.state.email === "") {
      message.error("Please enter email");
      return;
    } else if (!this.state.message) {
      message.error("Please enter message");
      return;
    } else {
      this.setState({
        loading: true,
      });
      const data = {
        entityData: {
          to: this.state.to,
          from: this.state.from,
          email: this.state.email,
          phone: this.state.phone,
          message: this.state.message,
        },
      };
      add(AppConfigs["needHelpMessage"], data)
        .then((result) => {
          console.log(result);
          if (result.success) {
            message.success(result.data.data);
            this.setState({
              loading: false,
              modalVisible: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalVisible: false,
          });
          console.log(error);
        });
    }
  };

  handleEventRender = (event, record) => {
    return (
      <>
        {event.changedFieldName === "firstName" ? (
          <>
            <p style={{ color: "black", fontSize: "14px" }}>
              First Name Changed from <b>{event.oldFields}</b> to{" "}
              <b>{event.modifiedField}</b>
            </p>
          </>
        ) : event.changedFieldName === "lastName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Last Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "richTextEditior" ? (
          <div style={{ display: "flex" }}>
            Notes Changed from &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.oldFields ? event.oldFields : ""}`,
              }}
            />{" "}
            &nbsp; to &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.modifiedField ? event.modifiedField : ""}`,
              }}
            />
          </div>
        ) : event.changedFieldName === "presentCreditAmount" &&
          "orderId" in record === true ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {"orderId" in record === true &&
              record.orderId !== "" &&
              "orderData" in record === true &&
              (record.orderData?.orderStatus === "OP" ||
                record.orderData?.orderStatus === "N") &&
              "orderData" in record === true &&
              "priceUpdatedStatus" in record.orderData === false && (
                <>
                  New Order <b>#{record.orderId}</b> Placed,{" "}
                </>
              )}{" "}
            {"orderData" in record === true &&
              record.orderData?.markAsPaid &&
              !record.orderData?.markAsInvoiced && (
                <>
                  Order #{record.orderId} <b>Marked as Paid</b>,{" "}
                </>
              )}
            {"orderData" in record === true &&
              record.orderData?.priceUpdatedStatus && (
                <>
                  Order <b>#{record.orderId}</b> Price Updated,{" "}
                </>
              )}
            {"orderData" in record === true &&
              record.orderData?.orderStatus === "D" &&
              !record.orderData?.markAsPaid &&
              !record.orderData?.markAsInvoiced && (
                <>
                  Order <b>#{record.orderId}</b> Marked as Delivered,{" "}
                </>
              )}
            Credit Available changed from{" "}
            <b>{event.oldFields !== "" && priceFormate(event.oldFields)}</b>
            {" to "}
            <b>{priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "creditAmount" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Credit Limit updated from{" "}
            <b>{event.oldFields !== "" && priceFormate(event.oldFields)}</b>
            {" to "}
            <b>{priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "address" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Address Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "phone" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Phone Changed from <b> {formatPhoneNumber(event.oldFields)} </b> to{" "}
            <b>{formatPhoneNumber(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "companyName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Company Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "location" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            New Location Added <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "approvalStatus" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {event.modifiedField === "A" ? (
              <b>Account approved </b>
            ) : (
              event.modifiedField === "F" && <b>Account Frozen</b>
            )}
          </p>
        ) : event.changedFieldName === "price" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Product{" "}
            {"productName" in record === true && <b> {record.productName}</b>}{" "}
            Price Changes to <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "isActive" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            <i> {event.productCode}</i> is
            {event.modifiedField ? <b> Activated </b> : <b> Deactivated </b>}
          </p>
        ) : (
          ""
        )}
      </>
    );
  };

  render() {
    let cartData = this.props.context.state.cartData;
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const imageUrl = this.state.profilePic;
    const { menuCollapsed } = this.state;
    const menuClass = menuCollapsed ? "collapsed" : "";
    const { Header } = Layout;
    const menu = (
      <Menu>
        <Menu.Item>
          <NavLink to="/app/profilesettings">Profile Settings</NavLink>
        </Menu.Item>
        <Menu.Item onClick={this.onLogout}>Log out</Menu.Item>
      </Menu>
    );

    const notificationData = (
      // <div style={{height: Object.keys(this.state.notifications).length > 5 && '400px', overflowY: Object.keys(this.state.notifications).length > 5 && 'scroll'}}>
      <div
        className={
          this.state.notificationsCount > 3
            ? "notificationpopupfull"
            : "notificationpopupempty"
        }
      >
        <Row>
          {Object.keys(this.state.notifications).map((day) => (
            <Row key={"row_" + day}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <div style={{ marginTop: "3%" }}>
                  <p>{day}</p>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div className="site-card-border-less-wrapper">
                      <Card
                        style={{
                          backgroundColor: "#F8F8F8",
                          borderRadius: "10px",
                          width: "500px",
                        }}
                        key={"card_" + day}
                      >
                        {this.state.notifications[day].map((data) => (
                          <Row
                            style={{
                              borderBottom: "1px solid lightgray",
                              marginTop: "1%",
                            }}
                            key={data["id"] + "_Row"}
                          >
                            {data["recordType"] === "order" && (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.openDeatilsPage(
                                    data["recordType"],
                                    data["recordId"],
                                    data["id"]
                                  );
                                }}
                              >
                                <Col lg={4} md={4} sm={24} xs={24}>
                                  <div
                                    style={{
                                      backgroundColor: "#FFF",
                                      width: "50px",
                                      height: "50px",
                                    }}
                                  >
                                    {data["isNew"] === true ? (
                                      <img
                                        src={orderLogo}
                                        style={{
                                          width: "17px",
                                          margin: "17px",
                                        }}
                                        alt="logo"
                                      />
                                    ) : (
                                      <img
                                        src={orderStatus}
                                        style={{
                                          width: "17px",
                                          margin: "17px",
                                        }}
                                        alt="logo"
                                      />
                                    )}
                                  </div>
                                </Col>
                                <Col lg={16} md={16} sm={24} xs={24}>
                                  {data["isNew"] === true ? (
                                    <>
                                      <h4 style={{ color: "black" }}>
                                        {"New Order #" + data["orderId"]}
                                      </h4>
                                      <p>
                                        <span style={{ color: "black" }}>
                                          {data["customerName"]
                                            ? data["customerName"] +
                                              ", " +
                                              data["companyName"]
                                            : data["createdBy"]}
                                        </span>{" "}
                                        just placed a new order{" "}
                                        <span style={{ color: "black" }}>
                                          {"#" + data["orderId"]}
                                        </span>
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <h4 style={{ color: "black" }}>
                                        Order status changed
                                      </h4>
                                      <p>
                                        <span style={{ color: "black" }}>
                                          {"Order #" + data["orderId"]}
                                        </span>{" "}
                                        status changed to &nbsp;
                                        {/* <Tag color="orange" style={{ borderRadius: '10px' }}>IN PROGRESS</Tag> */}
                                        <Tag
                                          color={
                                            AppConfigs["STATUS_COLORS"][
                                              data["orderNewStatus"]
                                            ]
                                          }
                                          style={{
                                            color: "black",
                                            height: "27px",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {
                                            AppConfigs["DISPLAY_LEAD_STATUS"][
                                              "admin"
                                            ][data["orderNewStatus"]]
                                          }
                                        </Tag>
                                      </p>
                                    </>
                                  )}
                                </Col>
                                <Col lg={4} md={4} sm={24} xs={24}>
                                  <span>
                                    {moment(data["createdAt"]).format(
                                      "hh:mm A"
                                    )}
                                  </span>
                                </Col>
                              </div>
                            )}
                            {(data["recordType"] === "customer" ||
                              data["recordType"] === "carrier") &&
                              data["isNew"] === true && (
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.openDeatilsPage(
                                      data["recordType"],
                                      data["recordId"],
                                      data["id"]
                                    );
                                  }}
                                >
                                  <Col lg={4} md={4} sm={24} xs={24}>
                                    <div
                                      style={{
                                        backgroundColor: "#FFF",
                                        width: "50px",
                                        height: "50px",
                                      }}
                                    >
                                      {data["recordType"] === "customer" ? (
                                        <img
                                          src={userLogo}
                                          style={{
                                            width: "17px",
                                            margin: "17px",
                                          }}
                                          alt="logo"
                                        />
                                      ) : (
                                        <img
                                          src={carrierTruck}
                                          style={{
                                            width: "25px",
                                            margin: "15px",
                                          }}
                                          alt="logo"
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  <Col lg={16} md={16} sm={24} xs={24}>
                                    <>
                                      <h4 style={{ color: "black" }}>
                                        {"New " +
                                          data["recordType"] +
                                          " signed up"}
                                      </h4>
                                      <p>
                                        <span style={{ color: "black" }}>
                                          {data["customerName"]
                                            ? data["customerName"] +
                                              ", " +
                                              data["companyName"]
                                            : data["createdBy"]}
                                        </span>{" "}
                                        {"just signed up as a new " +
                                          data["recordType"]}
                                      </p>
                                    </>
                                  </Col>
                                  <Col lg={4} md={4} sm={24} xs={24}>
                                    <span style={{ float: "right" }}>
                                      {moment(data["createdAt"]).format(
                                        "hh:mm A"
                                      )}
                                    </span>
                                  </Col>
                                </div>
                              )}
                          </Row>
                        ))}
                      </Card>
                    </div>
                  </Col>
                </div>
              </Col>
            </Row>
          ))}
          <div>
            <Col lg={24} md={24} sm={24} xs={24}>
              {/* <div style={{cursor:"pointer"}} onClick={() => {this.openDeatilsPage(data["recordType"],data["recordId"])}}> */}
              <span style={{ cursor: "pointer", color: "#1890ff" }}>
                <p style={{ textAlign: "center", marginTop: "4%" }}>
                  <span
                    onClick={() => {
                      this.openDeatilsPage("notifications", null, null);
                    }}
                    style={{ textDecoration: "underline" }}
                  >
                    Show all notifications
                  </span>
                  &nbsp;&nbsp;
                  {this.state.notificationsCount !== 0 && (
                    <span
                      onClick={() => {
                        this.openDeatilsPage("clear", null, null);
                      }}
                      style={{ textDecoration: "underline" }}
                    >
                      Clear all
                    </span>
                  )}
                </p>
              </span>
            </Col>
          </div>
        </Row>
      </div>
    );

    const auditColumns = [
      {
        title: "DATE AND TIME",
        dataIndex: "createdAt",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (createdAt) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {moment(createdAt).format("MM/DD/YYYY hh:mm a")}
          </p>
        ),
      },
      {
        title: "ACTION DONE BY",
        dataIndex: "firstName",
        key: "createdAt",
        align: "left",
        width: "35%",
        render: (firstName, record) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {record.firstName + " " + record.lastName}
          </p>
        ),
      },
      {
        title: "EVENT",
        dataIndex: "auditTrailDetails",
        key: "auditTrailDetails",
        render: (auditTrailDetails, record) => (
          <>
            {record.auditTrailDetails.map((change) =>
              this.handleEventRender(change, record)
            )}
          </>
        ),
      },
    ];

    const customerNotificationData = (
      <Row>
        <Table
          columns={auditColumns}
          dataSource={this.state.custmerNotifications}
          size="small"
          pagination={{ defaultPageSize: 5 }}
        />
        <div>
          <Col lg={24} md={24} sm={24} xs={24}>
            {/* <div style={{cursor:"pointer"}} onClick={() => {this.openDeatilsPage(data["recordType"],data["recordId"])}}> */}
            <span style={{ cursor: "pointer", color: "#1890ff" }}>
              <p style={{ textAlign: "center", marginTop: "4%" }}>
                <span
                  onClick={() => {
                    this.openDeatilsPage("notifications", null, null);
                  }}
                  style={{ textDecoration: "underline" }}
                >
                  Show all notifications
                </span>
                &nbsp;&nbsp;
                {this.state.notificationsCount !== 0 && (
                  <span
                    onClick={() => {
                      this.openDeatilsPage("clear", null, null);
                    }}
                    style={{ textDecoration: "underline" }}
                  >
                    Clear all
                  </span>
                )}
              </p>
            </span>
          </Col>
        </div>
      </Row>
    );
    const cartdata = (
      <div>
        {/* {this.state.opencart && */}

        <div
          // className="cartdiv"
          style={{
            height: cartData.length > 0 ? "500px" : "200px",
            overflowY: "auto",
          }}
        >
          <Spin spinning={this.state.cartLoading}>
            {cartData.length > 0 ? (
              <>
                {/* <h1>Stone Cart</h1> */}
                {cartData.map((item) => (
                  <Row
                    style={{ paddingTop: "20px" }}
                    key={item["productName"] + "-" + item["measurementType"]}
                  >
                    <Col span={5}>
                      <img
                        style={{
                          width: "75px",
                          height: "75px",
                          objectFit: "contain",
                        }}
                        src={item["image"]}
                        alt="img"
                      />
                    </Col>
                    <Col span={15}>
                      <Row style={{ marginLeft: "10px", height: "55px" }}>
                        <h3 className="cartitemtext">
                          {item["productName"].length > 20
                            ? item["productName"].substring(0, 19) +
                              "... - " +
                              item["size"] +
                              "  " +
                              item["deliveryTruck"]
                            : item["productName"] +
                              " - " +
                              item["size"] +
                              "  " +
                              item["deliveryTruck"]}
                        </h3>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <div style={{ float: "left" }}>
                            {item["quantity"] <= 1 ? (
                              <Button
                                disabled
                                className="quantitybtn"
                                onClick={() => {
                                  this.quantityDecrement(
                                    item,
                                    item["quantity"],
                                    item["id"]
                                  );
                                }}
                              >
                                -
                              </Button>
                            ) : (
                              <Button
                                className="quantitybtn"
                                onClick={() => {
                                  this.quantityDecrement(
                                    item,
                                    item["quantity"],
                                    item["id"]
                                  );
                                }}
                              >
                                -
                              </Button>
                            )}
                            <span className="count">{item["quantity"]}</span>
                            <Button
                              className="quantitybtn"
                              onClick={() => {
                                this.quantityIncrement(
                                  item,
                                  item["measurementType"],
                                  item["quantity"],
                                  item["id"]
                                );
                              }}
                            >
                              +
                            </Button>
                            <span
                              className="cartitemtext"
                              style={{ paddingTop: "5px", fontSize: "17px" }}
                            >
                              {" * $" +
                                parseFloat(item["totalAmt"] / item["quantity"])}
                            </span>
                          </div>
                          <Select
                            className="cartquantitydropdown"
                            notFoundContent={"Not found?!"}
                            defaultValue={item["measurementType"]}
                            onChange={(value) => {
                              this.changeMeasurementType(
                                value,
                                item["id"],
                                item["quantity"],
                                item["totalAmt"]
                              );
                            }}
                            style={{ width: "90px", fontSize: "16px" }}
                          >
                            {/* <Option value='ton'>Ton</Option> */}
                            <Option value="Pallet">Pallet</Option>
                            {/* <Option value='yard'>Yard</Option> */}
                            <Option value="Truckload">Truckload</Option>
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={4}>
                      <div>
                        <img
                          src={Trash}
                          alt="img"
                          title="remove"
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                          onClick={() => {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this item?"
                              )
                            )
                              this.deleteCartItem(item["id"]);
                          }}
                        />
                        <h3 className="cartitemcost">
                          {/* {"$" + item["totalAmt"]} */}
                          <NumberFormat
                            value={parseFloat(item["totalAmt"]).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                        </h3>
                      </div>
                    </Col>
                  </Row>
                ))}
                <Button
                  type="primary"
                  loading={this.state.loading}
                  htmlType="submit"
                  className="confirmorder"
                  onClick={this.checkout}
                >
                  CHECKOUT
                </Button>
              </>
            ) : (
              <h3 style={{ marginTop: "115px", color: "#7B8190" }}>
                You do not have any products added as yet.
              </h3>
            )}
            {/* <br />
          <span style={{ marginTop: "5px", color: "#7B8190" }}>Click on the cart again to close.</span> */}
          </Spin>
        </div>

        {/* } */}
      </div>
    );
    return (
      <>
        {userDetails &&
        (userDetails.userProfile === "A" || userDetails.userProfile === "M") ? (
          <Header
            style={{
              contentAlign: "center",
              backgroundColor: "rgb(14, 77, 144)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "225px",
              position: "relative",
            }}
          >
            <Row>
              <Col span={4}>
                <Link to="/app/loads">
                  <img
                    src={adminLogo}
                    style={{ width: "150px", marginBottom: "80px" }}
                    alt="logo"
                  />
                </Link>
              </Col>
              <Col span={20}>
                <div className="admin-header-menu">
                  <Menu mode="horizontal">
                    <Menu.Item key="1">
                      <NavLink
                        to="/app/loads"
                        activeStyle={{
                          color: "#1890ff",
                        }}
                      >
                        Loads
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="2">
                      <NavLink
                        to="/app/customers"
                        activeStyle={{
                          color: "#1890ff",
                        }}
                      >
                        Customers
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="3">
                      <NavLink
                        to="/app/carriers"
                        activeStyle={{
                          color: "#1890ff",
                        }}
                      >
                        Carriers
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="4">
                      <NavLink
                        to="/app/products"
                        activeStyle={{
                          color: "#1890ff",
                        }}
                      >
                        Products
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="5">
                      <NavLink
                        to="/app/settings"
                        activeStyle={{
                          color: "#1890ff",
                        }}
                      >
                        Settings
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item
                      key="6"
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "#0E4D90",
                      }}
                    >
                      <Row>
                        {/* <img src={userDetails["profilePicPath"] ? userDetails["profilePicPath"]: Profile} style={{ marginRight: '5px', border: '1px solid #7B8190', borderRadius: '50%', width:"50px", height: '50px' }} alt="Profile" /> */}
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            style={{
                              marginRight: "5px",
                              border: "1px solid #7B8190",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                            }}
                            alt="Profile"
                          />
                        ) : (
                          <img
                            src={Profile}
                            style={{
                              marginRight: "5px",
                              border: "1px solid #7B8190",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                            }}
                            alt="Profile"
                          />
                        )}

                        <Dropdown overlay={menu}>
                          <span style={{ color: "#FFF" }}>
                            {userDetails["firstName"] +
                              " " +
                              userDetails["lastName"]}{" "}
                            <DownOutlined />
                          </span>
                        </Dropdown>
                      </Row>
                    </Menu.Item>

                    <Menu.Item
                      key="7"
                      style={{
                        float: "right",
                        borderRight: "1px solid #A2AABD",
                      }}
                    >
                      <Popover
                        placement="bottom"
                        title={
                          <h2 style={{ textAlign: "center" }}>Notifications</h2>
                        }
                        content={notificationData}
                        visible={this.state.notificationVisible}
                        trigger="click"
                        onVisibleChange={this.notificationHandlechange}
                      >
                        <span style={{ color: "#FFF" }}>
                          <BellOutlined
                            style={{ color: "#FFF", fontSize: "1.4em" }}
                          />
                        </span>
                        {this.state.notificationsCount !== 0 && (
                          <Badge
                            count={this.state.notificationsCount}
                            style={{
                              backgroundColor: "#FF6C5E",
                              bottom: "14px",
                              right: "18px",
                            }}
                          ></Badge>
                        )}
                      </Popover>
                    </Menu.Item>
                  </Menu>
                </div>
              </Col>
            </Row>
          </Header>
        ) : (
          <Header
            className={
              this.props.location.pathname !== "/app/stones"
                ? "header"
                : "stonesheader"
            }
          >
            <Row>
              <Col span={3}>
                <div className="logo">
                  <Row>
                    <Col span={5} xs={12} sm={24} md={24} lg={24}>
                      {userDetails &&
                      (userDetails.userProfile === "CA" ||
                        userDetails.userProfile === "SCA") ? (
                        <Link to="/carrier_app/allOrders">
                          <img
                            src={newLogo}
                            style={{ width: "150px" }}
                            alt="logo"
                          />
                        </Link>
                      ) : userDetails.userProfile === "D" ? (
                        <Link to="/app/driver/todo">
                          <img
                            src={newLogo}
                            style={{ width: "150px" }}
                            alt="logo"
                          />
                        </Link>
                      ) : (
                        <Link to="/app/stones">
                          <img
                            src={newLogo}
                            style={{ width: "150px" }}
                            alt="logo"
                          />
                        </Link>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={21}>
                {userDetails &&
                  (userDetails.userProfile === "CA" ||
                    userDetails.userProfile === "SCA" ||
                    userDetails.userProfile === "D") && (
                    <div className="stones-menutab">
                      <Menu mode="horizontal" style={{ lineHeight: "64px" }}>
                        {(userDetails.userProfile === "CA" ||
                          userDetails.userProfile === "SCA") && (
                          <Menu.Item
                            key="8"
                            style={{ fontSize: "20px", color: "#0E4D90" }}
                          >
                            <NavLink
                              to="/carrier_app/allOrders"
                              activeStyle={{
                                color: "#0E4D90",
                                borderBottom: "2px solid #0E4D90",
                                width: "135px",
                              }}
                            >
                              Available Loads
                            </NavLink>
                          </Menu.Item>
                        )}
                        {(userDetails.userProfile === "CA" ||
                          userDetails.userProfile === "SCA") && (
                          <Menu.Item
                            key="9"
                            style={{ fontSize: "20px", color: "#0E4D90" }}
                          >
                            <NavLink
                              to="/carrier_app/myOrders"
                              activeStyle={{
                                color: "#0E4D90",
                                borderBottom: "2px solid #0E4D90",
                                width: "100px",
                              }}
                            >
                              My Loads
                            </NavLink>
                          </Menu.Item>
                        )}
                        {userDetails.userProfile === "CA" && (
                          <Menu.Item
                            key="10"
                            style={{ fontSize: "20px", color: "#0E4D90" }}
                          >
                            <NavLink
                              to="/carrier_app/drivers"
                              activeStyle={{
                                color: "#0E4D90",
                                borderBottom: "2px solid #0E4D90",
                                width: "100px",
                              }}
                            >
                              Drivers
                            </NavLink>
                          </Menu.Item>
                        )}
                        {userDetails.userProfile === "CA" && (
                          <Menu.Item
                            key="11"
                            style={{ fontSize: "20px", color: "#0E4D90" }}
                          >
                            <NavLink
                              to="/carrier_app/settings"
                              activeStyle={{
                                color: "#0E4D90",
                                borderBottom: "2px solid #0E4D90",
                                width: "100px",
                              }}
                            >
                              Settings
                            </NavLink>
                          </Menu.Item>
                        )}
                        {userDetails.userProfile === "D" && (
                          <Menu.Item
                            key="110"
                            style={{ fontSize: "20px", color: "#0E4D90" }}
                          >
                            <NavLink
                              to="/app/driver/todo"
                              activeStyle={{
                                color: "#0E4D90",
                                borderBottom: "2px solid #0E4D90",
                                width: "100px",
                              }}
                            >
                              Todo
                            </NavLink>
                          </Menu.Item>
                        )}
                        {userDetails.userProfile === "D" && (
                          <Menu.Item
                            key="111"
                            style={{ fontSize: "20px", color: "#0E4D90" }}
                          >
                            <NavLink
                              to="/app/driver/done"
                              activeStyle={{
                                color: "#0E4D90",
                                borderBottom: "2px solid #0E4D90",
                                width: "100px",
                              }}
                            >
                              Done
                            </NavLink>
                          </Menu.Item>
                        )}
                        <Menu.Item key="12" style={{ float: "right" }}>
                          <Button
                            type="primary"
                            htmlType="submit"
                            onClick={this.onLogout}
                          >
                            Logout
                          </Button>

                          {/* <img src={Exit} alt="Log-out" /> */}
                        </Menu.Item>
                        <Menu.Item
                          key="15"
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "#0E4D90",
                            borderRight: "1px solid #A2AABD",
                            cursor: "auto",
                          }}
                        >
                          <NavLink to="/carrier_app/carriersettings">
                            {/* <img src={userDetails["profilePicPath"] ? userDetails["profilePicPath"]: Profile} style={{ marginRight: '5px', border: '1px solid #7B8190', borderRadius: '50%', width: "50px", height: '50px' }} alt="Profile" />{userDetails["firstName"] + " " + userDetails["lastName"]} */}
                            {imageUrl ? (
                              <div>
                                <img
                                  src={imageUrl}
                                  style={{
                                    marginRight: "5px",
                                    border: "1px solid #7B8190",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                  }}
                                  alt="Profile"
                                />
                                {userDetails["firstName"] +
                                  " " +
                                  userDetails["lastName"]}
                              </div>
                            ) : (
                              <div>
                                <img
                                  src={Profile}
                                  style={{
                                    marginRight: "5px",
                                    border: "1px solid #7B8190",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                  }}
                                  alt="Profile"
                                />{" "}
                                {userDetails["firstName"] +
                                  " " +
                                  userDetails["lastName"]}
                              </div>
                            )}
                          </NavLink>
                        </Menu.Item>
                        <Menu.Item
                          key="14"
                          style={{
                            float: "right",
                            fontSize: "15px",
                            color: "#0E4D90",
                            borderRight: "1px solid #A2AABD",
                            cursor: "auto",
                          }}
                        >
                          <Popover
                            placement="bottom"
                            title={
                              <h2 style={{ textAlign: "center" }}>
                                Notifications
                              </h2>
                            }
                            content={notificationData}
                            visible={this.state.notificationVisible}
                            trigger="click"
                            onVisibleChange={this.notificationHandlechange}
                          >
                            <Tooltip
                              title="Notifications"
                              placement="bottom"
                              color="#2db7f5"
                            >
                              <span style={{ color: "rgb(162, 170, 189)" }}>
                                <BellOutlined
                                  style={{
                                    color: "rgb(162, 170, 189)",
                                    fontSize: "2.1em",
                                    fontWeight: "bold",
                                    paddingTop: "15px",
                                  }}
                                />
                              </span>
                            </Tooltip>
                            {this.state.notificationsCount !== 0 && (
                              <Badge
                                count={this.state.notificationsCount}
                                style={{
                                  backgroundColor: "#FF6C5E",
                                  bottom: "14px",
                                  right: "18px",
                                }}
                              ></Badge>
                            )}
                          </Popover>
                        </Menu.Item>
                        <Menu.Item
                          key="16"
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "#FF6C5E",
                            borderRight: "1px solid #A2AABD",
                          }}
                          onClick={() => {
                            this.setState({ modalVisible: true });
                          }}
                        >
                          <img
                            src={Call}
                            style={{ paddingRight: "5px" }}
                            alt="Help"
                          />
                          Need Help?
                        </Menu.Item>
                      </Menu>
                    </div>
                  )}
                {userDetails &&
                  (userDetails.userProfile === "CU" ||
                    userDetails.userProfile === "SCU") && (
                    <>
                      <Row
                        style={{ marginTop: "15px" }}
                        className="headerCURows"
                      >
                        <Col
                          span={4}
                          xs={12}
                          sm={24}
                          md={12}
                          lg={24}
                          className="headerCUCols"
                        >
                          <div
                            className={`stones-menutab ${menuClass}`}
                            style={{ lineHeight: "20px !important" }}
                          >
                            <Menu
                              mode={"horizontal"}
                              style={{
                                lineHeight: "20px !important",
                              }}
                              className="headerCUMenu"
                            >
                              <Menu.Item
                                key="17"
                                style={{
                                  fontSize: "20px",
                                  color: "grey",
                                  float: "left",
                                }}
                              >
                                <NavLink
                                  to="/app/stones"
                                  activeStyle={{
                                    color: "#0E4D90",
                                    borderBottom: "2px solid #0E4D90",
                                    width: "100px",
                                  }}
                                >
                                  Products
                                </NavLink>
                              </Menu.Item>
                              <Menu.Item
                                key="18"
                                style={{
                                  fontSize: "20px",
                                  color: "grey",
                                  float: "left",
                                }}
                              >
                                <NavLink
                                  to="/app/orders"
                                  activeStyle={{
                                    color: "#0E4D90",
                                    borderBottom: "2px solid #0E4D90",
                                    width: "100px",
                                  }}
                                >
                                  Orders
                                </NavLink>
                              </Menu.Item>
                              {userDetails.userProfile === "CU" && (
                                <Menu.Item
                                  key="19"
                                  style={{
                                    fontSize: "20px",
                                    color: "grey",
                                    float: "left",
                                  }}
                                >
                                  <NavLink
                                    to="/customer/settings"
                                    activeStyle={{
                                      color: "#0E4D90",
                                      borderBottom: "2px solid #0E4D90",
                                      width: "100px",
                                    }}
                                  >
                                    Settings
                                  </NavLink>
                                </Menu.Item>
                              )}
                              <Menu.Item key="20" style={{ float: "right" }}>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  onClick={this.onLogout}
                                >
                                  Logout
                                </Button>
                                {/* <img src={Exit} alt="Log-out" /> */}
                              </Menu.Item>

                              <Menu.Item
                                key="22"
                                style={{
                                  float: "right",
                                  fontSize: "20px",
                                  color: "#FF6C5E",
                                  borderRight: "1px solid #A2AABD",
                                }}
                                // onClick={this.opencart}
                              >
                                <Popover
                                  placement="bottom"
                                  title={<h2>Stone Cart</h2>}
                                  content={cartdata}
                                  visible={this.state.visible}
                                  trigger="click"
                                  onVisibleChange={this.handleVisibleChange}
                                >
                                  <Tooltip title="Cart" placement="bottom">
                                    <img
                                      src={Iconcart}
                                      style={{ paddingRight: "5px" }}
                                      alt="Help"
                                    />
                                    <Badge
                                      count={cartData.length}
                                      style={{ bottom: "10px", right: "10px" }}
                                    ></Badge>
                                  </Tooltip>
                                </Popover>
                              </Menu.Item>
                              <Menu.Item
                                key="23"
                                style={{
                                  float: "right",
                                  fontSize: "15px",
                                  color: "#0E4D90",
                                  borderRight: "1px solid #A2AABD",
                                  cursor: "auto",
                                }}
                              >
                                <Popover
                                  placement="bottom"
                                  title={
                                    <h2 style={{ textAlign: "center" }}>
                                      Notifications
                                    </h2>
                                  }
                                  content={customerNotificationData}
                                  visible={this.state.notificationVisible}
                                  trigger="click"
                                  onVisibleChange={
                                    this.notificationHandlechange
                                  }
                                >
                                  <Tooltip
                                    title="Notifications"
                                    placement="bottom"
                                  >
                                    <span
                                      style={{ color: "rgb(162, 170, 189)" }}
                                    >
                                      <BellOutlined
                                        style={{
                                          paddingLeft: "6px",
                                          fontWeight: "bold",
                                          paddingTop: "15px",
                                          right: "20px",
                                          color: "rgb(162, 170, 189)",
                                          fontSize: "2.1em",
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                  {this.state.notificationsCount !== 0 && (
                                    <Badge
                                      count={this.state.notificationsCount}
                                      style={{
                                        backgroundColor: "#FF6C5E",
                                        bottom: "14px",
                                        right: "18px",
                                      }}
                                    ></Badge>
                                  )}
                                </Popover>
                              </Menu.Item>
                              <Menu.Item
                                key="21"
                                style={{
                                  float: "right",
                                  fontSize: "20px",
                                  color: "black",
                                  borderRight: "1px solid #A2AABD",
                                  cursor: "auto",
                                }}
                              >
                                <NavLink to="/app/customersettings">
                                  {/* <img src={userDetails["profilePicPath"] ? userDetails["profilePicPath"]: Profile} style={{ marginRight: '5px', border: '1px solid #7B8190', borderRadius: '50%', width: "50px", height: '50px' }} alt="Profile" />{userDetails["firstName"] + " " + userDetails["lastName"]} */}
                                  {imageUrl ? (
                                    <div>
                                      <img
                                        src={imageUrl}
                                        style={{
                                          marginRight: "5px",
                                          border: "1px solid #7B8190",
                                          borderRadius: "50%",
                                          width: "50px",
                                          height: "50px",
                                        }}
                                        alt="Profile"
                                      />
                                      {userDetails["firstName"] +
                                        " " +
                                        userDetails["lastName"]}
                                    </div>
                                  ) : (
                                    <div>
                                      <img
                                        src={Profile}
                                        style={{
                                          marginRight: "5px",
                                          border: "1px solid #7B8190",
                                          borderRadius: "50%",
                                          width: "50px",
                                          height: "50px",
                                        }}
                                        alt="Profile"
                                      />{" "}
                                      {userDetails["firstName"] +
                                        " " +
                                        userDetails["lastName"]}
                                    </div>
                                  )}
                                </NavLink>
                              </Menu.Item>

                              <Menu.Item
                                key="24"
                                style={{
                                  // float: "left",
                                  fontSize: "20px",
                                  color: "#FF6C5E",
                                  borderRight: "1px solid #A2AABD",
                                }}
                                onClick={() => {
                                  this.setState({ modalVisible: true });
                                }}
                              >
                                <img
                                  src={Call}
                                  style={{ paddingRight: "5px" }}
                                  alt="Help"
                                />
                                Need Help?
                              </Menu.Item>
                            </Menu>
                          </div>
                          {/* <div style={{ textAlign: "center" }}>Test</div> */}
                        </Col>
                      </Row>
                      <Row>
                        <div
                          style={{
                            height: "10px",
                            textAlign: "center",
                            color: "red",
                          }}
                        >
                          {this.state.lowLimitErrorMsg}
                        </div>
                      </Row>
                    </>
                  )}
              </Col>
            </Row>

            <Modal
              // title="Contact Form"
              // className="modal-black-close"
              visible={this.state.modalVisible}
              width={"75vw"}
              onCancel={() =>
                this.setState({
                  modalVisible: false,
                })
              }
              footer={null}
              // style={{ padding: "5px" }}
              bodyStyle={{ padding: "0px" }}
            >
              <>
                <div
                  style={{
                    backgroundColor: "#414555",
                    padding: "5px",
                  }}
                  // className="messege-box-header-margin"
                >
                  <p
                    style={{
                      color: "#FFF",
                      textAlign: "center",
                      fontSize: "16px",
                      marginTop: "10px",
                    }}
                  >
                    Contact Form
                    <CloseOutlined
                      style={{
                        color: "white",
                        float: "right",
                        marginTop: "5px",
                        marginRight: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        this.setState({
                          modalVisible: false,
                        });
                      }}
                    />
                  </p>
                </div>

                <div className="messege-for-mobile-view">
                  <Row className="padding-Message">
                    <Col
                      xl={{ span: 4 }}
                      lg={{ span: 4 }}
                      md={{ span: 4 }}
                      xs={{ span: 5 }}
                      sm={{ span: 5 }}
                    >
                      <span className="messageTo">To:</span>
                    </Col>
                    <Col
                      xl={{ span: 18, offset: 2 }}
                      lg={{ span: 18, offset: 2 }}
                      md={{ span: 18, offset: 2 }}
                      xs={{ span: 18, offset: 1 }}
                      sm={{ span: 18, offset: 1 }}
                    >
                      <Input
                        disabled
                        name="to"
                        placeholder="To"
                        className="form-input"
                        value={this.state.to}
                        onChange={this.handleMailForm}
                        style={{
                          border: "1px solid #fff",
                          color: "black",
                          background: "white",
                        }}
                      />
                    </Col>
                  </Row>

                  <Divider style={{ margin: "5px" }}></Divider>

                  <Row className="padding-Message">
                    <Col
                      xl={{ span: 4 }}
                      lg={{ span: 4 }}
                      md={{ span: 4 }}
                      xs={{ span: 5 }}
                      sm={{ span: 5 }}
                    >
                      <span className="messageTo">From:</span>
                    </Col>
                    <Col
                      xl={{ span: 18, offset: 2 }}
                      lg={{ span: 18, offset: 2 }}
                      md={{ span: 18, offset: 2 }}
                      xs={{ span: 18, offset: 1 }}
                      sm={{ span: 18, offset: 1 }}
                    >
                      <Input
                        disabled={this.state.disableEdit}
                        name="from"
                        placeholder="From"
                        className="form-input"
                        value={this.state.from}
                        // onChange={this.handleMailForm}
                        style={{
                          border: "1px solid #fff",
                          color: "black",
                          background: "white",
                        }}
                      />
                    </Col>
                  </Row>

                  <Divider style={{ margin: "5px" }}></Divider>

                  <Row className="padding-Message">
                    <Col
                      xl={{ span: 4 }}
                      lg={{ span: 4 }}
                      md={{ span: 4 }}
                      xs={{ span: 5 }}
                      sm={{ span: 5 }}
                    >
                      <span className="messageTo">Email:</span>
                    </Col>
                    <Col
                      xl={{ span: 18, offset: 2 }}
                      lg={{ span: 18, offset: 2 }}
                      md={{ span: 18, offset: 2 }}
                      xs={{ span: 18, offset: 1 }}
                      sm={{ span: 18, offset: 1 }}
                    >
                      <Input
                        disabled={this.state.disableEdit}
                        name="email"
                        placeholder="Enter Email"
                        className="form-input"
                        value={this.state.email}
                        // onChange={this.handleMailForm}
                        style={{
                          border: "1px solid #fff",
                          color: "black",
                          background: "white",
                        }}
                      />
                    </Col>
                  </Row>

                  <Divider style={{ margin: "5px" }}></Divider>

                  <Row className="padding-Message">
                    <Col
                      xl={{ span: 4 }}
                      lg={{ span: 4 }}
                      md={{ span: 4 }}
                      xs={{ span: 5 }}
                      sm={{ span: 5 }}
                    >
                      <span className="messageTo">Phone:</span>
                    </Col>
                    <Col
                      xl={{ span: 18, offset: 2 }}
                      lg={{ span: 18, offset: 2 }}
                      md={{ span: 18, offset: 2 }}
                      xs={{ span: 18, offset: 1 }}
                      sm={{ span: 18, offset: 1 }}
                    >
                      <Input
                        disabled={this.state.disableEdit}
                        name="phone"
                        placeholder="Enter phone"
                        className="form-input"
                        value={formatPhoneNumber(this.state.phone)}
                        // onChange={this.handleMailForm}
                        style={{
                          border: "1px solid #fff",
                          color: "black",
                          background: "white",
                        }}
                      />
                    </Col>
                  </Row>

                  <Divider style={{ margin: "5px" }}></Divider>

                  <Row className="padding-Message">
                    <Col
                      xl={{ span: 4 }}
                      lg={{ span: 4 }}
                      md={{ span: 4 }}
                      xs={{ span: 5 }}
                      sm={{ span: 5 }}
                    >
                      <span className="messageTo">Message:</span>
                    </Col>
                    <Col
                      xl={{ span: 18, offset: 2 }}
                      lg={{ span: 18, offset: 2 }}
                      md={{ span: 18, offset: 2 }}
                      xs={{ span: 18, offset: 1 }}
                      sm={{ span: 18, offset: 1 }}
                    >
                      <TextArea
                        placeholder="Start typing"
                        rows={4}
                        name="message"
                        value={this.state.message}
                        onChange={this.handleMailForm}
                        style={{ border: "1px solid #fff" }}
                      />
                    </Col>
                  </Row>

                  <Divider style={{ margin: "5px" }}></Divider>
                  <div style={{ float: "right" }}>
                    <Button
                      key="submit"
                      type="primary"
                      loading={this.state.loading}
                      onClick={this.handleSendMail}
                      className="send-button-mobile-view"
                    >
                      <h6
                        style={{
                          color: "#FFF",
                          fontWeight: "bold",
                          fontSize: "14px",
                          marginTop: "5px",
                        }}
                      >
                        Send
                      </h6>
                    </Button>
                  </div>
                </div>
              </>
            </Modal>
            {/* {this.state.opencart &&
                          

            <div className="cartdiv">
              <Spin spinning={this.state.cartLoading}>
                {cartData.length > 0 ? <>
                  <h1>Stone Cart</h1>
                  {cartData.map((item) =>
                    <Row style={{ paddingTop: '20px' }} key={item["productName"] + "-" + item["measurementType"]}>
                      <Col span={7}>
                        <img style={{ width: '88px', height: '72px' }} src={item["image"]} alt="img" />
                      </Col>
                      <Col span={12}>
                        <Row>
                          <h3 className="cartitemtext" style={{ float: "left" }}>{item["productName"].length > 20 ? item["productName"].substring(0, 19) + "... - " + item["size"] + "  " + item["deliveryTruck"] : item["productName"] + " - " + item["size"] + "  " + item["deliveryTruck"]}</h3>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <div style={{ float: 'left' }}>
                              {item["quantity"] <= 1 ?
                                <Button disabled className="quantitybtn" onClick={() => { this.quantityDecrement(item["quantity"], item["id"]) }}>-</Button>
                                :
                                <Button className="quantitybtn" onClick={() => { this.quantityDecrement(item["quantity"], item["id"]) }}>-</Button>
                              }
                              <span className="count">{item["quantity"]}</span>
                              <Button className="quantitybtn" onClick={() => { this.quantityIncrement(item["quantity"], item["id"]) }}>+</Button>
                              <span className="cartitemtext" style={{ paddingTop: '5px', fontSize: '17px' }}>
                                {" * $" + item["amount"]}
                              </span>
                            </div>
                            <Select className="cartquantitydropdown"
                              notFoundContent={"Not found?!"}
                              defaultValue={item["measurementType"]}
                              onChange={(value) => { this.changeMeasurementType(value, item["id"]) }}
                              style={{ width: '90px', fontSize: '16px' }}
                            >
                              <Option value='ton'>Ton</Option>
                              <Option value='pallet'>Pallet</Option>
                              <Option value='yard'>Yard</Option>
                              <Option value='truckLoad'>Truckload</Option>
                            </Select>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={5}>
                        <img src={Trash} alt="img" style={{ cursor: "pointer" }} onClick={() => { if (window.confirm('Are you sure you want to delete this item?')) this.deleteCartItem(item["id"]) }} />
                        <h3 className="cartitemcost">{"$" + item["totalAmt"]}</h3>
                      </Col>
                    </Row>
                  )}
                  <Button type="primary" loading={this.state.loading} htmlType="submit" className="confirmorder" onClick={this.checkout} >
                    CHECKOUT
                  </Button></>
                  :
                  <h3 style={{ marginTop: "115px", color: "#7B8190" }}>You do not have any products added as yet.</h3>
                }
                <br />
                <span style={{ marginTop: "5px", color: "#7B8190" }}>Click on the cart again to close.</span>
              </Spin>
            </div>

          } */}
          </Header>
        )}
      </>
    );
  }
}

export default withAppContext(withRouter(Header));
